export default __webpack_public_path__ + "static/media/o-1.468ea1eb.jpg";